import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 6 6\" id=\"icon-close\">\r\n<style type=\"text/css\">\r\n\t#icon-close .st0{fill:'';}\r\n</style>\r\n<path class=\"st0\" d=\"M3.7,3l2.2-2.2C6,0.6,6,0.3,5.9,0.1C5.7,0,5.4,0,5.2,0.1L3,2.3L0.8,0.1C0.6,0,0.3,0,0.1,0.1S0,0.6,0.1,0.8\r\n\tL2.3,3L0.1,5.2C0,5.4,0,5.7,0.1,5.9C0.2,6,0.3,6,0.5,6s0.2,0,0.3-0.1L3,3.7l2.2,2.2C5.3,6,5.4,6,5.5,6s0.2,0,0.3-0.1\r\n\tC6,5.7,6,5.4,5.9,5.2L3.7,3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol